/*** IMPORTS FROM imports-loader ***/
import "core-js/modules/es.promise";
import "core-js/modules/es.array.iterator";

import { Loader } from '@googlemaps/js-api-loader';
import MarkerClusterer from '@googlemaps/markerclustererplus';
import MarkerFlorist from '../../images/florist-icon.svg';
import MarkerGardenCenter from '../../images/gardencenter-icon.svg';

const markerIconTypes = {
	'florist': MarkerFlorist,
	'gardencenter': MarkerGardenCenter
};

document.querySelectorAll('.sellingpoints-map[data-maps]').forEach(async el => {
	// Get config
	const config = JSON.parse(el.dataset.maps);

	// Load Google Maps
	await new Loader({
		apiKey: config.apiKey,
		language: document.documentElement.lang,
		libraries: ['places']
	}).load();
	const google = window.google;

	// Custom search
	const Search = (map, searchOptions) => {
		var options = Object.assign({
			position: google.maps.ControlPosition.LEFT_TOP,
			index: 1,
			value: null,
			placeholder: null
		}, searchOptions);

		const containerDiv = document.createElement('div');
		containerDiv.classList.add('search-container');
		containerDiv.index = options.index;

		const searchInput = document.createElement('input');
		searchInput.type = 'text';
		searchInput.value = options.value;
		searchInput.placeholder = options.placeholder;
		containerDiv.appendChild(searchInput);

		const searchBox = new google.maps.places.SearchBox(searchInput);

		map.controls[options.position].push(containerDiv);

		// Bias the SearchBox results towards current map's viewport
		map.addListener('bounds_changed', () => {
			searchBox.setBounds(map.getBounds());
		});

		searchBox.addListener('places_changed', () => {
			var place = searchBox.getPlaces().find(p => p.geometry && p.geometry.location);
			if (place) {
				map.setCenter(place.geometry.location);
				map.fitBounds(place.geometry.viewport);
			}
		});

		// Initial search
		if (options.value) {
			const placesService = new google.maps.places.PlacesService(map);
			placesService.textSearch({
				query: options.value
			}, (places) => {
				searchBox.set('places', places || []);
			});
		}
	};

	// Custom card
	const Card = (map, cardOptions) => {
		var options = Object.assign({
			position: google.maps.ControlPosition.LEFT_TOP,
			index: 1
		}, cardOptions);

		const containerDiv = document.createElement('div');
		containerDiv.classList.add('card-container');
		containerDiv.style.display = 'none';
		containerDiv.index = options.index;

		const closeButton = document.createElement('button');
		const span = document.createElement('span');
		span.classList.add('visuallyhidden');
		span.appendChild(document.createTextNode('Close'));
		closeButton.appendChild(span);
		closeButton.classList.add('close');
		closeButton.addEventListener('click', () => {
			functions.close();
		});
		containerDiv.appendChild(closeButton);

		const contentDiv = document.createElement('div');
		contentDiv.classList.add('content');
		containerDiv.appendChild(contentDiv);

		map.controls[options.position].push(containerDiv);

		const functions = {
			open: (content) => {
				contentDiv.innerHTML = content;
				containerDiv.style.display = null;
			},
			close: () => {
				containerDiv.style.display = 'none';
			}
		};

		return functions;
	};

	// Custom filter
	const Filter = (map, filterOptions, markersByType, markerClusterer) => {
		var options = Object.assign({
			position: google.maps.ControlPosition.BOTTOM_CENTER,
			index: 1,
			title: null,
			types: {}
		}, filterOptions);

		const containerDiv = document.createElement('div');
		containerDiv.classList.add('filter-container');
		containerDiv.index = options.index;

		if (options.title) {
			const span = document.createElement('span');
			span.classList.add('title');
			span.appendChild(document.createTextNode(options.title));
			containerDiv.appendChild(span);
		}

		Object.entries(options.types).forEach(entry => {
			const [key, value] = entry;

			if (!markersByType[key]) {
				return;
			}

			const checkbox = document.createElement('input');
			checkbox.type = 'checkbox';
			checkbox.name = 'type';
			checkbox.value = key;
			checkbox.checked = true;

			const label = document.createElement('label');
			const labelText = document.createElement('span');
			labelText.classList.add('label-text');
			label.appendChild(checkbox);
			label.appendChild(labelText);
			labelText.appendChild(document.createTextNode(value));
			containerDiv.appendChild(label);

			checkbox.addEventListener('click', () => {
				markersByType[key].forEach(m => {
					m.setVisible(checkbox.checked);
				});

				if (markerClusterer) {
					markerClusterer.repaint();
				}
			});

			const checkmark = document.createElement('span');
			checkmark.classList.add('checkmark');
			checkmark.classList.add(key);
			label.appendChild(checkmark);
		});

		map.controls[options.position].push(containerDiv);
	};

	// Create map
	const mapContainer = document.createElement('div');
	mapContainer.classList.add('sellingpoints-map');
	el.appendChild(mapContainer);

	const map = new google.maps.Map(mapContainer, {
		mapTypeControl: false,
		gestureHandling: "cooperative",
		styles: [{ "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [{ "color": "#444444" }] }, { "featureType": "landscape", "elementType": "all", "stylers": [{ "color": "#f2f2f2" }] }, { "featureType": "poi", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "road", "elementType": "all", "stylers": [{ "saturation": -100 }, { "lightness": 45 }] }, { "featureType": "road.highway", "elementType": "all", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "water", "elementType": "all", "stylers": [{ "color": "#d2e7e7" }, { "visibility": "on" }] }],
		center: {
			lat: 52.092876,
			lng: 5.104480
		},
		zoom: 5
	});

	// Fetch markers
	const response = await fetch(config.markers);
	const markersData = await response.json();

	// Add markers
	new Search(map, {
		value: config.search.value,
		placeholder: config.search.placeholder
	});
	var card = new Card(map, {
		index: 2
	});

	var markers = markersData.map(markerData => {
		const marker = new google.maps.Marker(markerData);
		marker.setIcon({
			url: markerIconTypes[markerData.type],
			anchor: new google.maps.Point(27, 60),
			scaledSize: new google.maps.Size(54, 80)
		});

		// Card content
		var content = '<h4>' + markerData.title + '</h4>';
		if (markerData.address) {
			content += '<p>' + markerData.address + '</p>';
			content += '<p>' + '<a href="' + 'https://maps.google.com/maps?daddr=' + markerData.address + '" target="_blank">' + config.card.routeTitle + '</a>' + '</p>';
		}
		if (markerData.url) {
			var urlText = markerData.url;
			if (markerData.urlText) {
				urlText = markerData.urlText;
			}
			content += '<a href="' + markerData.url + '" class="external" target="_blank">' + urlText + '</a>';
		}

		marker.addListener('click', () => {
			card.open(content);
		});

		return marker;
	});

	// Cluster all markers
	const markerClusterer = new MarkerClusterer(map, markers, {
		maxZoom: 17,
		ignoreHidden: true,
		styles: [{
			className: 'florist gardencenter',
			height: 50,
			width: 50
		}, {
			className: 'florist',
			height: 50,
			width: 50
		},
		{
			className: 'gardencenter',
			height: 50,
			width: 50
		}],
		calculator: (markers, numStyles) => {
			var index = 1;
			if (markers.every(m => m.type == 'florist')) index = 2;
			else if (markers.every(m => m.type == 'gardencenter')) index = 3;

			return {
				text: markers.length,
				index: Math.min(index, numStyles)
			};
		}
	});
	//markerClusterer.fitMapToMarkers();

	// Center map language based
	var lang = document.documentElement.lang;
	var country = 'Netherlands';

	if (lang == 'nl') {
		country = 'Netherlands';
	}
	else if (lang == 'de') {
		country = 'Germany';
	}
	else if (lang == 'en') {
		country = 'England';
	}

	var geocoder = new google.maps.Geocoder();
	geocoder.geocode({ 'address': country }, function (results, status) {
		if (status == google.maps.GeocoderStatus.OK) {
			map.setCenter(results[0].geometry.location);
			map.fitBounds(results[0].geometry.viewport);
		}
	});

	// Try HTML5 geolocation.
	if (navigator.geolocation) {
		navigator.geolocation.getCurrentPosition(
			(position) => {
				const pos = {
					lat: position.coords.latitude,
					lng: position.coords.longitude,
				};
				map.setCenter(pos),
					map.setZoom(14);
			}
		);
	}

	// Filter by type
	const markersByType = markers.reduce((acc, value) => {
		// Group initialization
		if (!acc[value.type]) {
			acc[value.type] = [];
		}

		// Grouping
		acc[value.type].push(value);

		return acc;
	}, {});

	new Filter(map, config.filter, markersByType, markerClusterer);
});